
const imgArray = [
  require('@/assets/head/img1.png'),
  require('@/assets/head/img2.png'),
  require('@/assets/head/img3.png'),
  require('@/assets/head/img4.png'),
  require('@/assets/head/img5.png')]

function RandomNum(Min, Max) {
  var Range = Max - Min;
  var Rand = Math.random();
  var num = Min + Math.round(Rand * Range);
  return num;
}


export default imgArray[RandomNum(0, 5)]



// WEBPACK FOOTER //
// ./src/api/headimgUrl.js